import { connect } from 'react-redux';
import { getAll, isLoading, isDestroying, getError, load, destroy } from 'store/modules/files';
import FileList from 'components/MediaLibrary/FileList';

const mapStateToProps = state => ({
  files: getAll(state),
  loading: isLoading(state),
  destroying: isDestroying(state),
  error: getError(state),
});

const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  destroy: id => dispatch(destroy(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FileList);
